<header class="dashboard-events-sidebar-header" [ngStyle]="style" [title]="'REPORTS.TITLE.EMPLOYEES_REPORT'| translate">
  <div class="row">
    <div class="row-inline" style="gap: 20px;">
      <div class="row-inline">
        @if (imageSvgPath) {
          <img [src]="imageSvgPath" class="mr-5" width="35" alt="" />
        }
        @if (iconClass) {
          <i [class]="iconClass"></i>
        }
        <h2 class="no-mg">{{title | translate}}</h2>
      </div>
      @if (showSearch) {
        <div class="cell">
          <span class="p-input-icon-left p-input-filled">
            <i class="pi pi-search"></i>
            <input type="text" pInputText [placeholder]="('REPORTS.TITLE.SEARCH_IN_REPORT'|translate)"
              #searchInput (input)="searchOnInput.emit(searchInput.value)" />
            </span>
          </div>
        }
      </div>
      @if (showMenu) {
        <div>
          <p-splitButton [label]="'COMMON.BUTTONS.EXPORT_EXCEL' |translate" [model]="this.items"
          (onClick)="exportReportOnClick('exportExcel')" [outlined]="true" styleClass="rtl-state"></p-splitButton>
        </div>
      }
    </div>
  </header>